import { Login } from '@platform/client';
import { Button, Icon, InlineFormInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { UnauthedPageWithNavbar } from '../../layout/UnauthedPageWithNavbar';

type FormValues = {
  email: string;
};

export const ForgotPasswordPage = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<FormValues>({ mode: 'onBlur' });

  const resetPasswordMutation = Login.useRequestPasswordReset({
    mutation: {
      onSuccess: () => {
        window.location.href =
          '/platform/auth/password-reset-email-verification?email=' + getValues('email') + '/';
      },
    },
  });

  const submitPasswordResetRequest: SubmitHandler<FormValues> = async (data) => {
    resetPasswordMutation.mutate({
      data: {
        email: data.email,
      },
    });
  };

  return (
    <UnauthedPageWithNavbar>
      <div className='w-full h-[80vh] flex flex-col gap-8 md:justify-center items-center p-4 overflow-y-scroll'>
        <h2 className='text-display-sm md:text-display-md'>Forgot your password?</h2>
        <div className='w-full md:w-[514px] text-lg text-center overflow-wrap'>
          Enter your email, if we have a record of it, we will email you instructions to reset your
          password.
        </div>
        <form
          className='flex flex-col gap-8 w-full md:w-[514px] max-w-[514px] items-center'
          name='login'
          onSubmit={handleSubmit(submitPasswordResetRequest)}
        >
          <InlineFormInput
            inputType='text'
            label='Email address'
            placeholder='Enter your email address'
            customWidth='w-full'
            autocomplete='email'
            errors={errors.email}
            register={() => {
              return register('email', {
                required: { value: true, message: 'Enter your email.' },
                pattern: {
                  value: /^\S+@\S+$/i,
                  message: 'Please enter a valid email address.',
                },
              });
            }}
          />
          <Button type='submit' variant='primary' size='md' additionalClassnames='w-[91px]'>
            Submit
          </Button>
        </form>
        <div className='w-full flex flex-row justify-center items-center'>
          <Button
            size='sm'
            variant='tertiary-color'
            href='/login'
            additionalClassnames='text-sm text-gray-500 font-semibold focus:bg-white active:text-gray-400 flex flex-row hover:bg-white items-center justify-center gap-1 w-[180px] max-w-[180px]'
          >
            <Icon type='arrow-left' size='20' />
            Back to Log in
          </Button>
        </div>
        <a className='underline text-brand-500' href='mailto:match@movingworlds.org'>
          Email us for help
        </a>
      </div>
    </UnauthedPageWithNavbar>
  );
};
